import ApiRequest from '../../../Apis/request'
import { middleofficeRequest } from '../../../axios'

export default class ApiFiscalYears {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async getFiscalYears(coproId) {
    try {
      const res = await middleofficeRequest.get(
        `middleoffice/condos/${coproId}/fiscal-years`
      )
      return res.data
    } catch (error) {
      return []
    }
  }

  async getExpenses(coproId, fiscalYearId, key) {
    try {
      const res = await middleofficeRequest.get(
        `middleoffice/condos/${coproId}/fiscal-years/${fiscalYearId}/rgdd/${key}`
      )
      return res.data
    } catch (error) {
      return []
    }
  }
}
